import { CONTENT } from "@/content";
import { BorderBeam } from "@/components/ui/border-beam";
import { Reveal } from "../ui/Reveal";
import { CTABand } from "../ui/CTABand";
import { SecHead } from "./SecHead";
import { motion } from "framer-motion";
type Props = { onCTA: () => void };

export function Trilhas({ onCTA }: Props) {
  const t = CONTENT.trilhas;
  return (
    <section className="section trilhas" id="trilhas">
      <div className="wrap">
        <SecHead label={t.label} title={t.title} intro={t.intro} align="split" />
        <Reveal className="trilhas-block-label">
          <span className="kicker-num">{t.blockTitle}</span>
        </Reveal>

        <div className="trilhas-bands">
          {t.cards.map((c, i) => {
            const rows: Array<[string, string]> = [
              ["Para quem é", c.who],
              ["Gargalo resolvido", c.gap],
              ["Situações práticas", c.situations],
              ["Formato", c.format],
            ];
            return (
              <Reveal as="article" key={c.key} className="band" delay={1}>
                <div className="band-head">
                  <span className="band-idx">
                    {String(i + 1).padStart(2, "0")} / {String(t.cards.length).padStart(2, "0")}
                  </span>
                  <h3 className="band-name serif">{c.key}</h3>
                  {c.flag && <span className="band-flag">{c.flag}</span>}
                  <p className="band-promise serif">{c.promise}</p>
                  <span className="band-level">
                    <b>Nível</b> {c.level}
                  </span>
                  <button className="btn btn-ghost band-cta btn-beam btn-beam-ghost" onClick={onCTA}>
                    <BorderBeam size={150} duration={8} />
                    {c.cta} <span className="arr">→</span>
                  </button>
                </div>
                <dl className="band-rows">
                  {rows.map(([k, v], j) => (
                    <div key={j} className="band-row">
                      <dt>{k}</dt>
                      <dd>{v}</dd>
                    </div>
                  ))}
                </dl>
              </Reveal>
            );
          })}
        </div>

        <div className="trilhas-foot">
          <CTABand lines={t.closing} cta={t.cta} onCTA={onCTA} />
        </div>
      </div>
    </section>
  );
}
